import React from 'react';
import { BaseLendingTile, BaseLendingTileParams } from '../BaseLendingTile';

import styles from './DeniedTile.module.scss';
import { LendingStatusBadgeEnum, LendingValueBadgeEnum } from '../types';
import { LendingStatusBadge, LendingValueBadge } from '../LendingBadge';

export type DeniedTileProps = Pick<
  BaseLendingTileParams,
  'financeSourceName' | 'financeImageUrl' | 'onClick' | 'isSelected' | 'height'
> & {
  message?: string;
};

export function DeniedTile({
  financeSourceName,
  financeImageUrl,
  message,
  onClick,
  isSelected,
  height,
}: DeniedTileProps) {
  const deniedStatusBadge = (
    <LendingStatusBadge statusBadge={LendingStatusBadgeEnum.DENIED} />
  );
  const deniedValueBadge = (
    <div className={styles.deniedTileValueBadge}>
      <LendingValueBadge valueBadge={LendingValueBadgeEnum.APPLICANT_DENIED} />
      <div data-testid="denied-tile-body">{message}</div>
    </div>
  );

  return (
    <BaseLendingTile
      statusBadge={deniedStatusBadge}
      valueBadge={deniedValueBadge}
      financeSourceName={financeSourceName}
      financeImageUrl={financeImageUrl}
      onClick={onClick}
      isSelected={isSelected}
      height={height}
      lendingValueBadge={LendingValueBadgeEnum.APPLICANT_DENIED}
    />
  );
}
